import { useState } from 'react';

const currentYear = new Date().getFullYear().toString();
const currentMonth = (new Date().getMonth() + 1).toString();
const defaults = { year: currentYear, month: currentMonth, scenario: '' };

const getTenantId = () => {
    try {
        const claim = JSON.parse(localStorage.getItem('kiln_claim') || '{}');
        return claim.tenant_id || '';
    } catch { return ''; }
};

const usePersistedFilter = (key) => {
    const tenantId = getTenantId();
    const storageKey = `kiln_filter_${key}_${tenantId}`;

    const [filter, setFilterState] = useState(() => {
        try {
            const stored = sessionStorage.getItem(storageKey);
            if (stored) return JSON.parse(stored);
        } catch { /* ignore */ }
        return defaults;
    });

    const setFilter = (newFilter) => {
        const updated = typeof newFilter === 'function' ? newFilter(filter) : newFilter;
        sessionStorage.setItem(storageKey, JSON.stringify(updated));
        setFilterState(updated);
    };

    return [filter, setFilter];
};

export default usePersistedFilter;
